import React from 'react';

const SalersRating = () => {
    return (
        <section class="rating">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="rating__text d-flex">
                <div class="rating-text__title">
                  Рейтинг продавцов
                </div>
                <div class="price-search__item search-item sm d-flex ml-auto">
                  <div class="sm__item psi1">
                    <a href="#"><i class="fas fa-globe"></i></a>
                  </div>
                  <div class="sm__item psi2">
                    <a href="#"><i class="fab fa-tiktok"></i></a>
                  </div>
                  <div class="sm__item psi3">
                    <a href="#"><i class="fab fa-youtube"></i></a>
                  </div>
                  <div class="sm__item psi4">
                    <a href="#"><i class="fab fa-vk"></i></a>
                  </div>
                  <div class="sm__item psi5">
                    <a href="#"><i class="fab fa-instagram"></i></a>
                  </div>
                  <div class="sm__item psi6">
                    <a href="#"><i class="fab fa-facebook-f"></i> </a>
                  </div>
                  <div class="sm__item psi7">
                    <a href="#"><i class="fab fa-odnoklassniki"></i></a>
                  </div>
                  <div class="sm__item psi8">
                    <a href="#"><i class="fab fa-telegram-plane"></i></a>
                  </div>
                </div>
              </div>
              <div class="rating__more d-flex">
                <div class="rating-more__first d-flex">
                  <div class="rating-more-first__item">
                    Продавец
                    <div class="rating-more-down">
                      <img src="img/down.svg" alt="down" />
                    </div>
                  </div>
                  <div class="rating-more-first__item">
                    Зарегистрирован
                    <div class="rating-more-down">
                      <img src="img/down.svg" alt="down" />
                    </div>
                  </div>
                  <div class="rating-more-first__item blue">
                    Отзывы
                    <div class="line"></div>
                    <div class="rating-more-down">
                      <img src="img/upblue.svg" alt="down" />
                    </div>
                  </div>
                </div>
                <div class="rating-more__second">
                  <div class="reting-more-text">
                    Последние группы
                    <div class="rating-more-down">
                      <img src="img/down.svg" alt="down" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="rating-info">
                <div class="rating__items">
                  <div class="rating__item d-flex">
                    <div class="rating-item__box rating-item-box">
                      <div class="rating-item-box__img">
                        <img src="img/ratinguser.png" alt="img" />
                      </div>
                      <div class="rating-item-box__name">
                        Максим
                      </div>
                    </div>
                    <div class="rating-item__box">
                      2020-07-01 в 21:41
                    </div>
  
                    <div class="rating-item__boxc d-flex ratingwidth">
                      <div class="rating-item-box__number blue">+130</div>
                      <div class="rating-item-box__number">2</div>
                      <div class="rating-item-box__number red">4</div>
                    </div>
                    <div class="rating-item__box d-flex">
                      <div class="rating-item-box__img">
                        <img src="img/ratinglogo.png" alt="img" />
                        <div class="rating-item-box__logo">
                          logo
                        </div>
                      </div>
                      <div class="rating-item-box__name tac">
                        группа "АРТЁМ МАТВЕЕВ
                      </div>
                    </div>
                  </div>
                  <div class="rating__item d-flex">
                    <div class="rating-item__box rating-item-box">
                      <div class="rating-item-box__img">
                        <img src="img/ratinguser.png" alt="img" />
                      </div>
                      <div class="rating-item-box__name">
                        Максим
                      </div>
                    </div>
                    <div class="rating-item__box">
                      2020-07-01 в 21:41
                    </div>
  
                    <div class="rating-item__boxc d-flex ratingwidth">
                      <div class="rating-item-box__number blue">+130</div>
                      <div class="rating-item-box__number">2</div>
                      <div class="rating-item-box__number red">4</div>
                    </div>
                    <div class="rating-item__box d-flex">
                      <div class="rating-item-box__img">
                        <img src="img/ratinglogo.png" alt="img" />
                        <div class="rating-item-box__logo">
                          logo
                        </div>
                      </div>
                      <div class="rating-item-box__name tac">
                        группа "АРТЁМ МАТВЕЕВ
                      </div>
                    </div>
                  </div>
                  <div class="rating__item d-flex">
                    <div class="rating-item__box rating-item-box">
                      <div class="rating-item-box__img">
                        <img src="img/ratinguser.png" alt="img" />
                      </div>
                      <div class="rating-item-box__name">
                        Максим
                      </div>
                    </div>
                    <div class="rating-item__box">
                      2020-07-01 в 21:41
                    </div>
  
                    <div class="rating-item__boxc d-flex ratingwidth">
                      <div class="rating-item-box__number blue">+130</div>
                      <div class="rating-item-box__number">2</div>
                      <div class="rating-item-box__number red">4</div>
                    </div>
                    <div class="rating-item__box d-flex">
                      <div class="rating-item-box__img">
                        <img src="img/ratinglogo.png" alt="img" />
                        <div class="rating-item-box__logo">
                          logo
                        </div>
                      </div>
                      <div class="rating-item-box__name tac">
                        группа "АРТЁМ МАТВЕЕВ
                      </div>
                    </div>
                  </div>
                  <div class="rating__item d-flex">
                    <div class="rating-item__box rating-item-box">
                      <div class="rating-item-box__img">
                        <img src="img/ratinguser.png" alt="img" />
                      </div>
                      <div class="rating-item-box__name">
                        Максим
                      </div>
                    </div>
                    <div class="rating-item__box">
                      2020-07-01 в 21:41
                    </div>
  
                    <div class="rating-item__boxc d-flex ratingwidth">
                      <div class="rating-item-box__number blue">+130</div>
                      <div class="rating-item-box__number">2</div>
                      <div class="rating-item-box__number red">4</div>
                    </div>
                    <div class="rating-item__box d-flex">
                      <div class="rating-item-box__img">
                        <img src="img/ratinglogo.png" alt="img" />
                        <div class="rating-item-box__logo">
                          logo
                        </div>
                      </div>
                      <div class="rating-item-box__name tac">
                        группа "АРТЁМ МАТВЕЕВ
                      </div>
                    </div>
                  </div>
                  <div class="rating__item d-flex">
                    <div class="rating-item__box rating-item-box">
                      <div class="rating-item-box__img">
                        <img src="img/ratinguser.png" alt="img" />
                      </div>
                      <div class="rating-item-box__name">
                        Максим
                      </div>
                    </div>
                    <div class="rating-item__box">
                      2020-07-01 в 21:41
                    </div>
  
                    <div class="rating-item__boxc d-flex ratingwidth">
                      <div class="rating-item-box__number blue">+130</div>
                      <div class="rating-item-box__number">2</div>
                      <div class="rating-item-box__number red">4</div>
                    </div>
                    <div class="rating-item__box d-flex">
                      <div class="rating-item-box__img">
                        <img src="img/ratinglogo.png" alt="img" />
                        <div class="rating-item-box__logo">
                          logo
                        </div>
                      </div>
                      <div class="rating-item-box__name tac">
                        группа "АРТЁМ МАТВЕЕВ
                      </div>
                    </div>
                  </div>
                  <div class="rating__item d-flex">
                    <div class="rating-item__box rating-item-box">
                      <div class="rating-item-box__img">
                        <img src="img/ratinguser.png" alt="img" />
                      </div>
                      <div class="rating-item-box__name">
                        Максим
                      </div>
                    </div>
                    <div class="rating-item__box">
                      2020-07-01 в 21:41
                    </div>
  
                    <div class="rating-item__boxc d-flex ratingwidth">
                      <div class="rating-item-box__number blue">+130</div>
                      <div class="rating-item-box__number">2</div>
                      <div class="rating-item-box__number red">4</div>
                    </div>
                    <div class="rating-item__box d-flex">
                      <div class="rating-item-box__img">
                        <img src="img/ratinglogo.png" alt="img" />
                        <div class="rating-item-box__logo">
                          logo
                        </div>
                      </div>
                      <div class="rating-item-box__name tac">
                        группа "АРТЁМ МАТВЕЕВ
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="reviews__breadcrumps breadcrumps d-flex">
                <div class="breadcrumps__left">
                  <img src="img/reviewsleft.png" alt="img" />
                </div>
                <div class="breadcrumps__list d-flex">
                  <div class="is-active">
                    <a href="#">
                      1
                    </a>
                  </div>
                  <div class="breadcrumps-list__item">
                    <a href="#">
                      2
                    </a>
                  </div>
                  <div class="breadcrumps-list__item">
                    <a href="#">
                      3
                    </a>
                  </div>
                  <div class="breadcrumps-list__item">
                    <a href="#">
                      4
                    </a>
                  </div>
                  <div class="breadcrumps-list__item">
                    <a href="#">
                      5
                    </a>
                  </div>
                </div>
                <div class="breadcrumps__right">
                  <img src="img/reviewsright.png" alt="img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default SalersRating;
